import {FETCH_COURSE,FETCH_COURSES_ALL,FETCH_COURSES_BY_SEARCH,LOADING_START,LOADING_END, FETCH_PREREQUISITES} from '../constants/actionConstants'


const CoursesReducer =  (state = {isLoading:false, courses: [], coursesFromSearch: [], prerequisites:[],
                         stats:{nCourses: 0,nStudents: 0,nProblems: 0,nNotebooks: 0,nCoursesTaken: 0,nFigures: 0,nEquations: 0,nInteractiveFigures: 0, nAnimations: 0}
            }, action) =>{
    switch(action.type){
        case FETCH_COURSES_ALL : 
            console.log(action.payload)
            return {...state, 
                courses: action.payload.courses,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
                stats:action.payload.stats,
    } ; 
        case FETCH_COURSES_BY_SEARCH :
            return {...state, coursesFromSearch: action.payload.data} ;         
        case FETCH_COURSE :
            return {...state, course: action.payload} ; 
        case FETCH_PREREQUISITES:
            return {...state, prerequisites: action.payload} ; 
        case LOADING_START :
            return {...state, isLoading: true} ;
        case LOADING_END:
            return {...state,  isLoading: false} ;            
        default:
            return state ; 
    }
} ; 

export default CoursesReducer ; 